import { css } from 'linaria';
import { styled } from 'linaria/react';
import { breakpoints } from '../../media';

export const CategoriesListingSection = styled.section`
	width: 100%;
`;

export const pageTitleStyles = css`
	${breakpoints.to.largeDesktop} {
		margin-bottom: 32px;
	}
	${breakpoints.to.tablet} {
		margin-bottom: 24px;
	}
`;

export const seoStyles = css`
	padding: 0;
	background-color: var(--background-primary);

	section {
		padding-inline: 0;
	}
`;
